const inputField = {
    props: {
        fieldSize: {
            default: 'mini'
        },
        control: {
            required: false,
            default: false
        },
        dataParent: {
            required: false,
            default: false
        },
        dataParentType: {
            required: false,
            default: 'object'
        },
        dataNameInParent: {
            required: false,
            default: 'YOU SHOULD SET ME'
        },
        whenUpatedParams: {
            required: false,
            default: null
        },
        whenUpatedParams: {
            required: false,
            default: null
        },
        label: {
            required: false
        },
        inputClass: {
            required: false,
            default: ''
        },
        name: {
            required: false
        },
        disabled: {
            required: false,
            default: false
        },
        readonly: {
            required: false,
            default: false
        },
        defaultValue: {
            required: false,
            default: null
        },
        defaultViewValue: {
            required: false
        },
        placeholder: {
            required: false,
            default: ''
        },
        editable: {
            required: false,
            default: true
        },
        label_span: {
            required: false,
            default: 21
        },
        field_span: {
            required: false,
            default: 21
        },
        field_mark: {
            required: false,
            default: 'optional'
        },
        rules: {
            required: false,
            default: null
        },
        inputPrepend: {
            required: false,
            default: false
        },
        inputAppend: {
            required: false,
            default: false
        },
        translateLabel: {        
            default: false
        },
        liveUpdate: {
            required: false,
            default: false
        },
        onMounted: {
            required: false,
            default: false
        },
        onMountedProps: {
            required: false,
            default: false
        }
    },
    data() {
        return {
            controller: this.$parent.$parent,
            validateMessage: null,
            binding: 'string'
        }
    },
    beforeMount() {
        if (this.control) {
            this.controller = this.control
            this.controller.$emit('registerField', {
                field: this
            });
        } else {
            this.updateValue = this.amUpdatedEvent
        }

        if (this.defaultViewValue) {
            this.field_value = this.defaultViewValue
            // we don't use updateValue here in order not to send unchanged data
        }

        if (this.defaultValue !== null) {
            this.field_value = this.defaultValue;
            this.updateValue();
        }
    },
    methods: {
        amUpdatedEvent() {
            this.$emit('amUpdated', {
                field: this,
                params: this.whenUpatedParams
            })
        },
        setValue(value) {
            this.field_value = value;
            this.updateValue();
        },
        updateValue() {
            this.controller.$emit('updateFieldValue', {
                field: this
            })
            this.amUpdatedEvent()
        }
    }
};

export default inputField
